import { uCheckLang } from '../ucheck/ucheck.lang';
import { __Direction } from './general';
import { __UserData, __AuthStatus, __Questioner } from './register';
import { __PortalPublish, __Publish, __ReportDetail, __WorkSpace } from './ucheck';
export interface __ReduxAction<T> {
    type: string;
    payload: T;
}

export enum __Calender {
    gregorian = 'gregorian',
    jalali = 'jalali',
}

export interface __ReduxState {
    lang: typeof uCheckLang;
    authStatus: __AuthStatus;
    direction: __Direction;
    userData: __UserData | null;
    publishData: __Publish | null;
    workspacesData: __WorkSpace[] | null;
    publishesData: __Publish[] | null;
    calender: __Calender;
    kioskData: __Publish | null;
    expired: boolean;
    portalPublishData: __PortalPublish | null;
    answerDetail: null | __ReportDetail;
}
